export default __webpack_public_path__ + "static/media/05.39e998e9.jpg";